// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"341":"af3daec1","994":"36ead312"}[chunkId] + ".chunk.js";
};